
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface DetailButtonProps {
  href: string; // Cambiato da onClick a href
  isHomePage?: boolean;
}

export function DetailButton({ href, isHomePage = false }: DetailButtonProps) {
  return (
    <Button 
      variant="outline"
      size="sm"
      className={cn(
        "flex-1 font-medium",
        isHomePage && "bg-background/80 hover:bg-background/90"
      )}
      asChild // Importante: indica a Button di utilizzare il componente figlio (Link)
    >
      <Link to={href}>
        <ExternalLink className="mr-1 h-4 w-4" />
        Dettagli
      </Link>
    </Button>
  );
}
